import { handleActions } from 'redux-actions'
import Immutable from 'immutable'

import * as actions from '../actions/scoreLog';

const initialState = Immutable.fromJS({
  data: [],
  export: {},
  loading: false,
  loaded: false
})

export default handleActions({
  // 积分查询
  [actions.getScoreLogSucceeded](state, { payload }) {
    return state.set('loading', false).set('loaded', true)
      .set('data', Immutable.fromJS(payload.data));
  },
  [actions.getScoreLogFailed](state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  },
  // 用户积分导出
  [actions.getScoreLogExportRequested](state) {
    return state.delete('error').set('loading', true)
  },
  [actions.getScoreLogExportSucceeded](state, { payload }) {
    return state.set('loading', false).set('loaded', true).update('export', v => v.merge(Immutable.fromJS(payload)));
  },
  [actions.getScoreLogExportFailed](state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  }
}, initialState)



// WEBPACK FOOTER //
// ./reducers/scoreLog.js